import ClientImageBrowser from '../../../components/client-image-browser/ClientImageBrowser';
import './galleries.scss'

const Galleries = () => {
    return (
        <div className='galleriesHome'>

            <ClientImageBrowser
                baseURL={process.env.REACT_APP_BASE_URL}
            />

        </div>
    )
}

export default Galleries